import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from '../../services/auth.service';

@Component({selector: 'app-apply-reset',
  templateUrl: './apply-reset.component.html',
  standalone: false,
})
export class ApplyResetComponent implements OnInit {
  title: string;
  subtitle: string;
  form: FormGroup;

  constructor(private fb: FormBuilder,
    private authService: AuthService,
    private translate: TranslateService,
    private messageService: MessageService,
    private router: Router) {
  }

  ngOnInit(): void {
    this.checkRequestedPasswordReset();
    this.initTranslation();
    this.initForm();
  }

  private initForm() {
    this.form = this.fb.group({
      password: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]],
    });
  }

  private checkRequestedPasswordReset() {
    if (!this.authService.requestedPasswordReset) {
      this.router.navigate(['/auth/login']);
    }
  }

  async onSubmit() {
    if (this.form.valid) {
      // check if passwords match
      const formValue = this.form.value as { password: string; confirmPassword: string }
      if (formValue.password !== formValue.confirmPassword) {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('AUTH.ERRORS.PASSWORDS_DONT_MATCH.TITLE'),
          detail: this.translate.instant('AUTH.ERRORS.PASSWORDS_DONT_MATCH.MESSAGE')
        });
        return;
      }
      // send request to server
      try {
        const data = await this.authService.applyReset(formValue.password).toPromise();
        if (data?.success) {
          // notify user, wait 3 seconds and redirect to login
          this.messageService.add({
            severity: 'success',
            icon:'pi pi-check-circle color-success',
            summary: this.translate.instant('AUTH.ERRORS.RESET_SUCCESS.TITLE'),
            detail: this.translate.instant('AUTH.ERRORS.RESET_SUCCESS.MESSAGE')
          })
          setTimeout(() => {
            this.router.navigate(['/auth/login']);
          }, 3000);
        } else {
          this.messageService.add({
            severity: 'error',
            summary: this.translate.instant('AUTH.ERRORS.RESET_FAILED.TITLE'),
            detail: this.translate.instant('AUTH.ERRORS.RESET_FAILED.MESSAGE')
          });
        }
      } catch (_e) {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('AUTH.ERRORS.RESET_FAILED.TITLE'),
          detail: this.translate.instant('AUTH.ERRORS.RESET_FAILED.MESSAGE')
        });
      }
    } else {
      this.messageService.add({
        severity: 'error',
        summary: this.translate.instant('AUTH.ERRORS.FORM_INVALID.TITLE'),
        detail: this.translate.instant('AUTH.ERRORS.FORM_INVALID.MESSAGE')
      });
    }
  }

  private initTranslation() {
    this.title = this.translate.instant('AUTH.APPLY_RESET.TITLE');
    this.subtitle = this.translate.instant('AUTH.APPLY_RESET.SUBTITLE');
  }
}
